import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ListItemLink, ListItemButton } from '@wix/da-ds/pkg/List/ListItem';
const GoToTier = ({ deviation, stopPropagation, anchorless })=>{
    const { t } = useTranslation();
    const openTier = useCallback(()=>{
        window.location.href = deviation.url;
    }, [
        deviation
    ]);
    if (anchorless) {
        return /*#__PURE__*/ React.createElement(ListItemButton, {
            label: t('deviationview.tierCard.moreActionsMenu.item.goToTierPage'),
            onClick: openTier,
            fillContainerWidth: true,
            stopPropagation: stopPropagation
        });
    }
    return /*#__PURE__*/ React.createElement(ListItemLink, {
        label: t('deviationview.tierCard.moreActionsMenu.item.goToTierPage'),
        href: deviation.url,
        stopPropagation: stopPropagation
    });
};
GoToTier.displayName = 'GoToTier';
export default GoToTier;

//# sourceMappingURL=GoToTier.js.map